<template>
    <PageContent>
        <PageTitle>Kitchen Fresh Users <Help /></PageTitle>
        <NotReady v-if="!ready" />
        <div v-else>
            <div class="text-end mb-3">
                <a :href="`/users/create`" class="btn btn-primary ms-1">New User</a>
            </div>

            <DataTable :options="tableOptions" :columns="[
                { data: 'User Code' },
                { data: 'Name' },
                { data: 'Mapped Route No' },
                { data: null, orderable: false, searchable: false }
              ]" ref="dataTable" class="display table table-sm table-striped table-bordered" style="width:100%">

              <thead>
                <tr>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">User Name</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Name</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Route</th>
                  <th style="background-color: var(--bs-gray-700); color: var(--bs-white);"></th>
                </tr>
                <tr>
                  <td><label class="filter-label">User Name</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchColumn(0, $event)" /></td>
                  <td><label class="filter-label">Name</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchColumn(1, $event)" /></td>
                  <td><label class="filter-label">Route</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchColumn(2, $event)" /></td>
                  <td></td>
                </tr>
              </thead>

              <template #column-0="{ rowData }">
                {{ rowData['User Code'] }}
                <div>
                  <span class="badge bg-secondary me-1" v-if="rowData['Admin']">Admin</span>
                  <span class="badge bg-secondary me-1" v-if="rowData['Status']==0||rowData['Status']==1">Active</span>
                </div>
              </template>

              <template #column-3="{ rowData }">
                <span style="white-space: nowrap;">
                  <a :href="`/users/${rowData['User Code']}/edit`" class="me-1 mt-1 mb-1 btn btn-sm btn-primary">Edit</a>
                  <a @click.prevent.stop="deleteUser(rowData)" class="me-1 mt-1 mb-1 btn btn-sm btn-danger">Delete</a>
                </span>
              </template>
            </DataTable>
        </div>
    </PageContent>
  </template>
  
  <script>
    import PageContent from '@/components/PageContent.vue';
    import NotReady from '@/components/NotReady.vue';
    import PageTitle from '@/components/PageTitle.vue';
    import Help from '@/components/Help.vue';
    import VueSimpleAlert from 'vue3-simple-alert';
    import axios from 'axios';
    import DataTable from 'datatables.net-vue3'
    import DataTablesCore from 'datatables.net-bs5'

    DataTable.use(DataTablesCore)

    export default {
        name: 'Users',
        components: {PageContent, PageTitle, NotReady, Help, DataTable},
        data(){
            return {
                ready: false,
                tableOptions: null,
            }
        },
        created(){
            this.tableOptions = {
                pageLength: this.$store.state.localStorage.user['Users_Per_Page'] ?? 25,
                lengthMenu: [[25, 50, 100, -1], [25, 50, 100, 'All']],
                scrollX: true,
                scrollY: '60vh',
                scrollCollapse: true,
                orderCellsTop: true,
                processing: true,
                serverSide: true,
                order: [[0, 'asc']],
                columnDefs: [{ targets: '_all', orderSequence: ['asc', 'desc'] }],
                ajax: {
                    url: `${this.$store.state.api}/users?token=${localStorage.token}`,
                    type: 'GET',
                    data: (data) => {
                        return {
                            draw: data.draw,
                            start: data.start,
                            length: data.length,
                            search: data.search.value,
                            orderBy: data.columns[data.order[0].column].data,
                            orderDir: data.order[0].dir,
                            'User Code': data.columns[0].search.value,
                            'Name': data.columns[1].search.value,
                            'Mapped Route No': data.columns[2].search.value,
                        };
                    },
                },
            };
        },
        async mounted(){
            this.ready = true;
            await this.$nextTick();
            this.$refs.dataTable.dt.on('length.dt', (e, settings, len) => {
                this.$store.state.localStorage.user['Users_Per_Page'] = len;
                localStorage.setItem('user', JSON.stringify(this.$store.state.localStorage.user));
            });
        },
        methods:{
            searchColumn: _.debounce(function(colIndex, event){
                this.$refs.dataTable.dt.column(colIndex).search(event.target.value).draw();
            }, 300),
            async deleteUser(user){
                let result;
                try{
                    result = await VueSimpleAlert.confirm(`Are you sure you want to delete the user: ${user.Name}?`, `Delete User`);
                } catch(err){
                    result = false;
                }
                if(!result) return;

                user['Deleted'] = '1';
                let formData = new FormData();
                formData.append('user', JSON.stringify(user));
                let res = await axios.post(`${this.$store.state.api}/delete_user?`, formData);

                if(res.message == 'success'){
                    this.$refs.dataTable.dt.draw();
                }
            },
        },
    }
  </script>
<style lang="scss">
@import 'datatables.net-bs5';

table.dataTable thead tr th,
table.dataTable tbody tr td,
table.dataTable tbody tr th {
  white-space: nowrap !important;
  font-size: 0.85rem;
}

table.dataTable thead tr th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.filter-label {
  display: none;
  font-size: 0.75rem;
  font-weight: bold;
  text-align: left;
  margin-bottom: 0.2rem;
}

@media (max-width: 992px) {
  .filter-label {
    display: block;
  }
  .dt-scroll-body {
    height: auto !important;
  }
  table.dataTable {
    display: block;

    thead {
      display: block;

      tr:first-child {
        display: none;
      }

      tr:nth-child(2) {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        padding: 0.5rem;
        background-color: var(--bs-gray-200);
        border-bottom: 1px solid var(--bs-gray-300);

        td {
          flex: 1 1 45%;
          padding: 0;

          input {
            width: 100%;
          }

          &:last-child {
            display: none;
          }
        }
      }
    }

    tbody {
      display: block;

      tr {
        display: block;
        border: 1px solid var(--bs-gray-300);
        border-radius: 0.375rem;
        margin-bottom: 1rem;
        padding: 0.5rem 0.75rem;

        td {
          display: block;
          width: 100%;
          border: none;
          padding: 0.15rem 0;
          white-space: normal !important;

          &:nth-of-type(1)::before {
            content: 'User Name: ';
            font-weight: bold;
          }
          &:nth-of-type(2)::before {
            content: 'Name: ';
            font-weight: bold;
          }
          &:nth-of-type(3)::before {
            content: 'Route: ';
            font-weight: bold;
          }
          &:last-child {
            text-align: right;
            padding-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
